import React from 'react';
import { styled } from '@compiled/react';
import { graphql, useFragment } from 'react-relay';
import { token } from '@atlaskit/tokens';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import type { providerLogo_softwareReleasesLaunchCard$key } from '@atlassian/jira-relay/src/__generated__/providerLogo_softwareReleasesLaunchCard.graphql';
import fallbackProviderLogoUrl from './assets/addon.svg';

type Props = {
	provider: providerLogo_softwareReleasesLaunchCard$key;
};

export const ProviderLogo = ({ provider }: Props) => {
	const { name, logoUrl } = useFragment(
		graphql`
			fragment providerLogo_softwareReleasesLaunchCard on DevOpsDeploymentProvider {
				name
				logoUrl
			}
		`,
		provider,
	);
	return (
		<CircularLogo
			src={logoUrl ?? ''}
			alt={name ?? ''}
			title={name ?? ''}
			onError={(e) => {
				if (e.target instanceof HTMLImageElement) {
					e.target.src = fallbackProviderLogoUrl;
				}
			}}
		/>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CircularLogo = styled.img({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${gridSize * 4}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${gridSize * 4}px`,
	paddingTop: token('space.100'),
	paddingRight: token('space.100'),
	paddingBottom: token('space.100'),
	paddingLeft: token('space.100'),
	borderRadius: '100%',
	// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
	boxShadow: '0px 3px 5px rgba(9, 30, 66, 0.2), 0px 0px 1px rgba(9, 30, 66, 0.31)',
	// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
	backgroundColor: 'white',
});
